import { viewport } from './global';
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

// add element to body for accurately reporting viewport size

let $body = document.querySelector('body');

const vpSizeCheck = (w,h) => {
    if(w != viewport.vw || h != viewport.vh) {
        window.requestAnimationFrame(() => {
            if(w != viewport.vw) {
                viewport.setVw(w);
                document.documentElement.style.setProperty('--vpWidth', `${viewport.vw}px`);
            }
            if(h != viewport.vh) {
                viewport.setVh(h);
                document.documentElement.style.setProperty('--vpHeight', `${viewport.vh}px`);
            }
        });
    }
};

// add element to body

const vpSizer = document.createElement('div');
vpSizer.setAttribute('id','vp-sizer');
vpSizer.setAttribute('aria-hidden','true');
vpSizer.setAttribute('style','position:fixed;z-index:-1;top:0;left:0;bottom:0;right:0;pointer-events:none');
$body.appendChild(vpSizer);

// add resize observer

const vpSizerResizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        const cr = entry.contentRect;
        vpSizeCheck(cr.width,cr.height);
    }
});

vpSizerResizeObserver.observe(vpSizer);